"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_query_1 = require("@tanstack/react-query");
const useMessages = () => {
    const fetchFunc = () => axios.get('/api/get-messages').then((response) => response.data.data);
    return (0, react_query_1.useQuery)({ queryKey: ['get-messages'], queryFn: fetchFunc });
};
exports.default = useMessages;
